module.exports = __webpack_public_path__ + "img/calendar-filter.73fb0b74.svg";